module.exports = __webpack_public_path__ + "favicon.ico";


//////////////////
// WEBPACK FOOTER
// ./favicon.ico
// module id = 415
// module chunks = 0